import {initContract} from '@ts-rest/core';
import {z} from 'zod';
import {DB_SCHEMAS} from '../db/schemaExports';

const c = initContract();

const appConfigSchema = DB_SCHEMAS.selectAppConfig;

export const appConfigsContract = c.router({
  list: {
    method: 'GET',
    path: '/app-configs',
    responses: {
      200: z.array(appConfigSchema),
      403: z.object({message: z.string()})
    },
    summary: 'List all app configs'
  },
  listCurrent: {
    method: 'GET',
    path: '/app-configs/current',
    responses: {
      200: z.array(appConfigSchema),
      403: z.object({message: z.string()})
    },
    summary: 'List all current app configs'
  },
  getByKey: {
    method: 'GET',
    path: '/app-configs/key/:key',
    pathParams: z.object({
      key: z.string()
    }),
    responses: {
      200: appConfigSchema,
      403: z.object({message: z.string()}),
      404: z.object({message: z.string()})
    },
    summary: 'Get current config by key'
  },
  update: {
    method: 'PUT',
    path: '/app-configs/key/:key',
    pathParams: z.object({
      key: z.string()
    }),
    body: z.object({
      value: z.string()
    }),
    responses: {
      200: appConfigSchema,
      403: z.object({message: z.string()}),
      404: z.object({message: z.string()})
    },
    summary: 'Update config value (creates new version, marks old as not current)'
  }
});
